/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

/**
 * @COMPONENT_NAME MachineTypeStateTransitionHistory
 * @DESCRIPTION   설비의 상태 전이 이력을 관리하는 화면 컴포넌트
 *                설비별 상태 전이 이력 조회 화면을 제공         
 *
 * @PASSTHROUGH_PROPS
 * @CALLBACKS
 *   - {Function} onApiInitialized - API 초기화 시 호출되는 콜백
 *   - {Function} onInitialized - 그리드 초기화 시 호출되는 콜백
 */

const MachineTypeStateTransitionHistory = () => {
    const table = "MachineTypeStateTransitionHistory";
    const view = "VwMachineTypeStateTransitionHistory";

    const [schema, setSchema] = useState();
    const [grid, setGrid] = useState();
    const [api, setApi] = useState();
    const [machineTypeStateTransitionHistorySelect, setMachineTypeStateTransitionHistorySelect] = useState();

    const { t } = useTranslation();

    useEffect(() => {
        let mounted = true;

        async function schemaSetting() {
            let schema = await getSchema(table);
            if (mounted) {
                setSchema(schema);
            }
        }

        schemaSetting();
        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        if (grid) {
            grid.selectionChanged.addHandler((grid, event) => {
                if (grid.selectedItems && grid.selectedItems[0]) {
                    setMachineTypeStateTransitionHistorySelect(grid.selectedItems[0]);
                } else {
                    setMachineTypeStateTransitionHistorySelect([]);
                }
            });

            grid.itemsSourceChanged.addHandler((grid, event) => {
                if (grid.selectedItems && grid.selectedItems[0]) {
                    setMachineTypeStateTransitionHistorySelect(grid.selectedItems[0]);
                } else {
                    setMachineTypeStateTransitionHistorySelect([]);
                }
            });
        }
    }, [grid]);

    const onApiInitialized = (api) => {
        setApi(api);
    };

    const onInitialized = (grid) => {
        setGrid(grid);
    };

    return (
        <BasicCrudScreenType
            id={table}
            table={table}
            view={view}
            onInitialized={onInitialized}
            onApiInitialized={onApiInitialized}
            noCreate
            noEdit
            noDelete
            noExcel
        />
    );
};

export default MachineTypeStateTransitionHistory;
